export default "__VITE_ASSET__BnBMAjfx__"